<template>
    <div class="content-desc">{{ formInput.formData.appDesc }}</div>
</template>

<script setup>
import {
    ref,
    onMounted,
    getCurrentInstance,
    defineExpose,
    defineProps,
    reactive,
} from "vue";

import Qs from "qs";
import { VXETable } from "vxe-table";

const { proxy } = getCurrentInstance();
const props = defineProps({
    appId: {
        // 查询类型
        type: String,
        default: "",
    },
});
const formInput = reactive({
    formData: {
        Id: "",
        status: "0",
        appName: "名称",
        appDesc: "",
        appIcon: "",
        mcpServeName: "",
        isRemote: "",
        creatorUID: "",
        CreateMan: "",
        creationTime: "",
        appClassId: "",
        labelId: "",
        fPathPackage: "",
    },
});

const loadData = (appId) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [appId],
    };
    proxy.$api.componentManageAPI
        .getComponentOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            formInput.formData = res.data.Data;
        })
        .catch((error) => {
            console.log(error);
        });
};
onMounted(() => {
    loadData(props.appId);
});
</script>

<style scoped>
.content-desc {
    font-size: 14px;
    line-height: 1.6;
    color: #374151; /* 深灰色，比纯黑柔和 */
    padding: 10px 10px; /* 内边距，给文字留呼吸感 */
    margin-top: 10px;

}
</style>
